// extracted by mini-css-extract-plugin
export default {"DownloadAppBG":"styles_DownloadAppBG__inW1i","EvolveIcon":"styles_EvolveIcon__SxE25","Title":"styles_Title__pWEm4","SubTitle":"styles_SubTitle__b-6kR"};